import Vue from 'vue'
import Vuex from 'vuex'
import * as types from './mutation-types'

Vue.use(Vuex)

export default new Vuex.Store({
  state () {
    return {
      layout: 'default',
      profile: null,
      currentPermissions: [],
      token: localStorage.getItem('token'),
      userId: localStorage.getItem('userId'),
      loadingOverlay: false,
      prefectures: null,
      dataChart: {},
      mapInit: false,
      previewUpdateTime: '',
      productionUpdateTime: '',
      isResponseError: false
    }
  },
  getters: {
    profile: state => state.profile,
    hasToken: state => state.token,
    userId: state => state.userId,
    layout: state => state.layout || 'default',
    prefectures: state => state.prefectures,
    dataChart: state => state.dataChart,
    currentPermissions: state => state.currentPermissions,
    mapInit: state => state.mapInit,
    previewUpdateTime: state => state.previewUpdateTime,
    productionUpdateTime: state => state.productionUpdateTime,
    isResponseError: state => state.isResponseError
  },
  mutations: {
    setIsResponseError (state, payload) {
      state.isResponseError = payload
    },
    [types.SET_PREFECTURES] (state, payload) {
      state.prefectures = payload
    },
    [types.SET_CHART] (state, payload) {
      state.dataChart = payload
    },
    [types.START_LOADING] (state) {
      state.loadingOverlay = true
      document.getElementById('loading').style.opacity = 'block'
    },
    [types.END_LOADING] (state) {
      state.loadingOverlay = false
      document.getElementById('loading').style.display = 'none'
    },
    [types.SET_LAYOUT] (state, { layout }) {
      state.layout = layout
    },
    [types.SET_PROFILE] (state, { profile }) {
      state.profile = profile
      localStorage.setItem('email', profile.data.user.email)
    },
    [types.SET_TOKEN] (state, data) {
      state.token = data.token
      localStorage.setItem('token', data.token)
      localStorage.setItem('refresh-token', data.refreshToken)
    },
    [types.SET_USER_ID] (state, userId) {
      state.userId = userId
      localStorage.setItem('userId', userId)
    },
    [types.SET_PERMISSION] (state, permissions) {
      state.currentPermissions = permissions
    },
    [types.LOG_OUT] (state) {
      state.token = null
      state.profile = null
      localStorage.removeItem('token')
      localStorage.removeItem('userId')
      localStorage.removeItem('refresh-token')
    },
    setMapInit (state, payload) {
      state.mapInit = payload
    },
    [types.SET_APP_UPDATE_TIME] (state, data) {
      state.previewUpdateTime = data.preview
      state.productionUpdateTime = data.production
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js